/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Represents a US home address
 */
export interface HomeAddressModel {
  /** Street address */
  street_address?: string | null;
  /** Apartment, suite, etc. */
  street_address_2?: string | null;
  /** City */
  city?: string | null;
  /** State abbreviation (e.g., 'CA', 'NY') */
  state?: string | null;
  /** ZIP code */
  zip_code?: string | null;
}
